'use client'

import type { FC } from 'react'
import UserSearchSelect from '../UserSearchSelect'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const UserSearchField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <UserSearchSelect
                name={field.name}
                label={field.label as string}
                placeholder={field.placeholder}
                value={value as string | IUser | IUserMini | undefined}
                onChange={v => onChange(field.name, v, field)}
                disabled={!!field?.disabled}
            />
        </FieldWrapper>
    )
}

export default UserSearchField
